module.exports = __webpack_public_path__ + "img/relacionescolor-silgan.57032acd.png";